export const accountDetailsContents = {
  labels: {
    disbursalAccountDetails: "Disbursal Bank Account Details",
    bankName: "Bank Name",
    IFSC: "IFSC Code",
    accountNumber: "Account Number",
    instruction: `Your documentation is getting checked by the backend team. Meanwhile, please 
    configure the above mentioned account with your customer for the repayments. Please note
     that credit approval will be on hold until confirmation.`
  }
};
